import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

const PlaceDescriptionAdmin = () => {
  const [places, setPlaces] = useState([]);
  const [editingPlace, setEditingPlace] = useState(null);
  const [loading, setLoading] = useState(true);

  // --- YENİ EKLENEN STATE'LER ---
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Sayfa başına kaç kayıt gösterilecek

  // Verileri çek
  useEffect(() => {
    fetchPlaces();
  }, []);

  // Arama terimi değiştiğinde sayfayı 1'e sıfırla
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const fetchPlaces = async () => {
    try {
      const response = await fetch(`${API_URL}/admin/place-descriptions`);
      const data = await response.json();
      setPlaces(data);
      setLoading(false);
    } catch (error) {
      console.error('Veri çekme hatası:', error);
      setLoading(false);
    }
  };

  const handleEditClick = (place) => {
    setEditingPlace({ ...place });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditingPlace((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/admin/place-descriptions/${editingPlace.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editingPlace),
      });

      if (response.ok) {
        alert('Güncelleme Başarılı!');
        setEditingPlace(null);
        fetchPlaces();
      } else {
        alert('Güncelleme sırasında hata oluştu.');
      }
    } catch (error) {
      console.error('Hata:', error);
    }
  };

  // --- FİLTRELEME VE SAYFALAMA MANTIĞI ---

  // 1. Arama Filtresi
  const filteredPlaces = places.filter((place) =>
    place.place_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    place.style?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // 2. Sayfalama Hesaplamaları
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPlaces.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredPlaces.length / itemsPerPage);

  // Sayfa Değiştirme Fonksiyonu
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) {
    return (
      <div className="dark flex justify-center items-center h-screen bg-gray-50 dark:bg-gray-900">
        <div className="text-xl font-semibold text-gray-600 dark:text-gray-300">Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div className="dark min-h-screen bg-gray-50 dark:bg-gray-900 p-6 font-sans transition-colors duration-300">
      <div className="max-w-7xl mx-auto">
        
        {/* HEADER VE ARAMA KISMI */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-6 border-b border-gray-200 dark:border-gray-700 pb-4 gap-4">
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
            Mekanname İçerik Yönetimi
          </h2>
          
          <div className="relative w-full md:w-1/3">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
                </svg>
            </div>
            <input 
              type="text" 
              className="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
              placeholder="Mekan ara..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {/* LİSTELEME TABLOSU */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md dark:shadow-gray-900/50 overflow-hidden transition-colors duration-300 flex flex-col min-h-[500px]">
          <div className="overflow-x-auto flex-grow">
            <table className="min-w-full bg-white dark:bg-gray-800">
              <thead>
                <tr className="bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 uppercase text-sm leading-normal">
                  <th className="py-3 px-6 text-left">ID</th>
                  <th className="py-3 px-6 text-left">Mekan Adı</th>
                  <th className="py-3 px-6 text-left">Stil</th>
                  <th className="py-3 px-6 text-center">İşlemler</th>
                </tr>
              </thead>
              <tbody className="text-gray-600 dark:text-gray-400 text-sm font-light">
                {currentItems.length > 0 ? (
                  currentItems.map((place) => (
                    <tr key={place.id} className="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition duration-150">
                      <td className="py-3 px-6 text-left whitespace-nowrap font-medium">{place.id}</td>
                      <td className="py-3 px-6 text-left">
                        <span className="font-semibold text-gray-800 dark:text-gray-100">{place.place_name}</span>
                      </td>
                      <td className="py-3 px-6 text-left">
                        <span className="bg-blue-100 dark:bg-blue-900/50 text-blue-600 dark:text-blue-200 py-1 px-3 rounded-full text-xs font-semibold">
                          {place.style}
                        </span>
                      </td>
                      <td className="py-3 px-6 text-center">
                        <button
                          onClick={() => handleEditClick(place)}
                          className="bg-blue-500 hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-xs transition duration-200 shadow-sm"
                        >
                          Düzenle
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="py-6 text-center text-lg text-gray-500 dark:text-gray-400">
                      Kayıt bulunamadı.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* SAYFALAMA KONTROLLERİ (FOOTER) */}
          {totalPages > 1 && (
            <div className="flex justify-between items-center px-6 py-4 bg-gray-50 dark:bg-gray-700/30 border-t border-gray-200 dark:border-gray-700">
              <span className="text-sm text-gray-600 dark:text-gray-400">
                Toplam <strong>{filteredPlaces.length}</strong> kayıttan <strong>{indexOfFirstItem + 1}-{Math.min(indexOfLastItem, filteredPlaces.length)}</strong> arası gösteriliyor
              </span>
              
              <div className="flex space-x-1">
                <button
                  onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                  className={`px-3 py-1 rounded text-sm font-medium ${
                    currentPage === 1 
                      ? 'bg-gray-200 dark:bg-gray-600 text-gray-400 cursor-not-allowed' 
                      : 'bg-white dark:bg-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-500 border border-gray-300 dark:border-gray-500'
                  }`}
                >
                  Önceki
                </button>
                
                {/* Sayfa Numaraları (Basit versiyon) */}
                {[...Array(totalPages)].map((_, i) => (
                  // Çok fazla sayfa varsa burayı daraltmak gerekebilir, şimdilik hepsi
                  <button
                    key={i}
                    onClick={() => paginate(i + 1)}
                    className={`px-3 py-1 rounded text-sm font-medium border ${
                      currentPage === i + 1
                        ? 'bg-blue-500 text-white border-blue-500'
                        : 'bg-white dark:bg-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-500 border-gray-300 dark:border-gray-500'
                    }`}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className={`px-3 py-1 rounded text-sm font-medium ${
                    currentPage === totalPages
                      ? 'bg-gray-200 dark:bg-gray-600 text-gray-400 cursor-not-allowed' 
                      : 'bg-white dark:bg-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-500 border border-gray-300 dark:border-gray-500'
                  }`}
                >
                  Sonraki
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* DÜZENLEME MODALI (DEĞİŞİKLİK YOK) */}
      {editingPlace && (
        <div className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 flex justify-center items-center z-50 p-4 overflow-y-auto backdrop-blur-sm">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl dark:shadow-black/50 w-full max-w-2xl transform transition-all border dark:border-gray-700">
            <div className="flex justify-between items-center p-6 border-b border-gray-200 dark:border-gray-700">
              <h3 className="text-xl font-bold text-gray-800 dark:text-white">
                Düzenle: <span className="text-blue-600 dark:text-blue-400">{editingPlace.place_name}</span>
              </h3>
              <button
                onClick={() => setEditingPlace(null)}
                className="text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300 transition duration-150 text-2xl font-bold focus:outline-none"
              >
                &times;
              </button>
            </div>

            <form onSubmit={handleSave} className="p-6 space-y-4">
              <div>
                <label className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2">Mekan Adı</label>
                <input
                  type="text"
                  name="place_name"
                  value={editingPlace.place_name}
                  onChange={handleInputChange}
                  className="shadow-sm appearance-none border dark:border-gray-600 rounded w-full py-2 px-3 text-gray-700 dark:text-white bg-white dark:bg-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                />
              </div>

              <div>
                <label className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2">Tarihçe (Maks 600)</label>
                <textarea
                  name="tarihce"
                  rows="4"
                  value={editingPlace.tarihce || ''}
                  onChange={handleInputChange}
                  className="shadow-sm appearance-none border dark:border-gray-600 rounded w-full py-2 px-3 text-gray-700 dark:text-white bg-white dark:bg-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition resize-y"
                />
              </div>

              <div>
                <label className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2">Fotoğraf Rehberi</label>
                <textarea
                  name="fotograf_rehberi"
                  rows="3"
                  value={editingPlace.fotograf_rehberi || ''}
                  onChange={handleInputChange}
                  className="shadow-sm appearance-none border dark:border-gray-600 rounded w-full py-2 px-3 text-gray-700 dark:text-white bg-white dark:bg-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition resize-y"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2">İlginç Bilgi</label>
                  <textarea
                    name="ilginc_bilgi"
                    rows="3"
                    value={editingPlace.ilginc_bilgi || ''}
                    onChange={handleInputChange}
                    className="shadow-sm appearance-none border dark:border-gray-600 rounded w-full py-2 px-3 text-gray-700 dark:text-white bg-white dark:bg-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition resize-y"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2">Yakınındaki Yerler</label>
                  <textarea
                    name="yakinindaki_yerler"
                    rows="3"
                    value={editingPlace.yakinindaki_yerler || ''}
                    onChange={handleInputChange}
                    className="shadow-sm appearance-none border dark:border-gray-600 rounded w-full py-2 px-3 text-gray-700 dark:text-white bg-white dark:bg-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition resize-y"
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-3 pt-4 border-t border-gray-100 dark:border-gray-700 mt-4">
                <button
                  type="button"
                  onClick={() => setEditingPlace(null)}
                  className="bg-red-500 hover:bg-red-600 dark:bg-red-600 dark:hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-150"
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="bg-green-600 hover:bg-green-700 dark:bg-green-700 dark:hover:bg-green-800 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-150"
                >
                  Değişiklikleri Kaydet
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlaceDescriptionAdmin;